import React, { memo, PropsWithChildren, ReactNode } from "react";
import Backdrop from "components/backdrop/Backdrop";
import modalStyles from "../Modal.module.scss";
import styles from "./NotifModal.module.scss";
import Footer from "../../footer/Footer";
import { Button, ButtonSize, ButtonVariant } from "@bale/ui";
import classNames from "classnames";
import isEqual from "react-fast-compare";

type Props = PropsWithChildren<{
  onClose?: () => void;
  title: string;
  icon?: ReactNode;
  primaryButton: {
    onClick: () => void;
    label: string;
    color?: string;
    variant?: ButtonVariant;
    disable?: boolean;
  };
  secondaryButton?: {
    onClick: () => void;
    label: string;
    color?: string;
    variant?: ButtonVariant;
  };
  content?: string;
  mobileBottomSheet?: boolean;
  primaryLoading?: boolean;
}>;

const NotifModal: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <Backdrop
      className={classNames(modalStyles.Container, {
        [modalStyles.bottomSheet]: props.mobileBottomSheet,
      })}
      isOpen={true}
      onClick={props.onClose}
    >
      <div
        className={classNames(modalStyles.FormWrapper, {
          [modalStyles.bottomSheet]: props.mobileBottomSheet,
        })}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.Header} title={props.title}>
          {props.icon && props.icon}
          {props.title}
        </div>
        <div className={modalStyles.Wrapper}>
          {props.content ? (
            <p className={classNames(modalStyles.Content, styles.Content)}>
              {props.content}
            </p>
          ) : (
            props.children
          )}
        </div>
        <Footer
          className={classNames(modalStyles.Footer, {
            [modalStyles.bottomSheet]: props.mobileBottomSheet,
          })}
        >
          <div className={modalStyles.buttons}>
            <Button
              text={props.primaryButton.label}
              size={
                props.secondaryButton ? ButtonSize.Small : ButtonSize.XLarge
              }
              style={{ width: "100%" }}
              onClick={props.primaryButton.onClick}
              color={props.primaryButton.color}
              variant={props.primaryButton.variant}
              disable={props.primaryButton.disable}
              loading={props.primaryLoading}
            />
          </div>
        </Footer>
      </div>
    </Backdrop>
  );
};

export default memo(NotifModal, isEqual);
